import api from "./api"

export const getAptListAPI = async ({ keyword = "", page = 1, size = 10 }) => {
  const { data } = await api.get("/api/admin/apts", {
    params: { keyword, page, size }
  })
  return data
}

export const createAptAPI = async ({
  kapt_code,
  road_code,
  sgg_code,
  apt_name,
  region_key,
  road_addr,
  move_in_date,
  heat_type
}) => {
  const { data } = await api.post("/api/admin/apts", {
    kapt_code,
    road_code,
    sgg_code,
    apt_name,
    region_key,
    road_addr,
    move_in_date,
    heat_type
  })
  return data
}

export const updateAptAPI = async (list) => {
  const { data } = await api.patch("/api/admin/apts", list)
  return data
}

export const deleteAptAPI = async ({ kapt_code }) => {
  const { data } = await api.delete(`/api/admin/apts/${kapt_code}`)
  return data
}

export const getRoadAddrSearchAPI = async ({ sido, sgg, road }) => {
  const { data } = await api.get("/api/admin/road-match", {
    params: { sido, sgg, road }
  })
  return data
}

// * 유저 관리
export const getUserListAPI = async ({ keyword = "", page = 1, size = 10 }) => {
  const { data } = await api.get("/api/admin/users", {
    params: { keyword, page, size }
  })
  return data
}

export const createUserAPI = async ({ user_id, user_name, password, phone, scope_code }) => {
  const { data } = await api.post("/api/admin/users", {
    user_id,
    user_name,
    password,
    phone,
    scope_code
  })
  return data
}

export const updateUserAPI = async (list) => {
  const { data } = await api.patch("/api/admin/users", list)
  return data
}

export const deleteUserAPI = async ({ user_id }) => {
  const { data } = await api.delete(`/api/admin/users/${user_id}`)
  return data
}

export const getLogsAPI = async ({ keyword = "", page = 1, size = 10 }) => {
  const { data } = await api.get("/api/admin/logs", {
    params: { keyword, page, size }
  })
  return data
}

export const getAptUnitSizeAPI = async ({ kapt_code = "" }) => {
  const { data } = await api.get(`/api/admin/apts/${kapt_code}/unit-size`)
  return data
}

export const saveAptUnitSizeAPI = async ({ kapt_code, dong, hos, palette }) => {
  const { data } = await api.post(`/api/admin/apts/${kapt_code}/unit-size`, {
    dong,
    hos,
    palette
  })
  return data
}

// * 그룹 관리
export const getGroupListAPI = async ({ keyword = "", page = 1, size = 10 }) => {
  const { data } = await api.get("/api/admin/groups", {
    params: { keyword, page, size }
  })
  return data
}

export const createGroupAPI = async ({ group_name, codes }) => {
  const { data } = await api.post("/api/admin/groups", {
    group_name,
    codes
  })
  return data
}

export const updateGroupAPI = async (list) => {
  const { data } = await api.patch("/api/admin/groups", list)
  return data
}

export const deleteGroupAPI = async ({ group_id }) => {
  const { data } = await api.delete(`/api/admin/groups/${group_id}`)
  return data
}
